// extracted by mini-css-extract-plugin
export default {"ValueContainer":"TLoYPP3e"};